import axios from "axios";
import { apiURL } from "./constants";

/**
 * List shipment tag catalog (GET /api/shipment_tags/).
 * @param {string} search - optional name search
 * @param {number} page - page index (1-based per project patterns)
 * @param {number} pageSize
 */
export async function getShipmentTags(search = "", page = 1, pageSize = 100) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("access_token")}`;
  const q = search == null ? "" : search;
  const response = await axios.get(
    `${apiURL}/api/shipment_tags/?page=${page}&page_size=${pageSize}&search=${encodeURIComponent(q)}`,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response;
}

/**
 * Map selected tag names (as in ShipmentTagsOptionList value) to `tags` query string (comma-separated ids).
 * Uses one catalog page; names not found are omitted.
 */
export async function fetchTagsQueryParamFromNames(names) {
  if (!Array.isArray(names) || names.length === 0) return null;
  const res = await getShipmentTags("", 1, 500);
  const results = res && res.data && res.data.results;
  if (!Array.isArray(results)) return null;
  const map = new Map();
  for (const t of results) {
    if (t && t.name != null && t.id != null) {
      map.set(String(t.name).toLowerCase(), t.id);
    }
  }
  const ids = [];
  const seen = new Set();
  for (const n of names) {
    const id = map.get(String(n).toLowerCase());
    if (id != null && !seen.has(id)) {
      seen.add(id);
      ids.push(id);
    }
  }
  return ids.length > 0 ? ids.join(",") : null;
}

/**
 * Create a catalog tag (POST /api/shipment_tags/). Requires shipment_tags_create.
 * @param {{ name: string, color?: string | null }} data
 */
export async function postShipmentTag(data) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("access_token")}`;
  const response = await axios.post(`${apiURL}/api/shipment_tags/`, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response;
}

/**
 * Full update of a catalog tag (PUT /api/shipment_tags/<id>/). Requires shipment_tags_update.
 * @param {number} id
 * @param {{ name: string, color?: string | null }} data
 */
export async function putShipmentTag(id, data) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("access_token")}`;
  const response = await axios.put(`${apiURL}/api/shipment_tags/${id}/`, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response;
}

/**
 * Remove a tag from the catalog (DELETE /api/shipment_tags/<id>/). Requires shipment_tags_delete or equivalent.
 */
export async function deleteShipmentTag(id) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("access_token")}`;
  const response = await axios.delete(`${apiURL}/api/shipment_tags/${id}/`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response;
}
